import { useTranslation } from "../i18n";
import ReportsAdmin from "../components/ReportsAdmin";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin-settings.css";

// Admin › Warehouse › Reports: pick a report and a warehouse, download the
// file. The catalogue lives on the BE (app/warehouse/services/reports.js).
const AdminReports = () => {
    const { t } = useTranslation();
    return (
        <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="reports_title"
                backTo="/admin/warehouse"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                    { labelKey: "reports_title" },
                ]}
            />
            <div className="admin-settings-section">
                <p className="admin-settings-section-hint">{t("reports_hint")}</p>
                <ReportsAdmin />
            </div>
        </div>
    );
};

export default AdminReports;
